import { Plus, Edit, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function ProductsTab({ products, onCreateNew, onEdit, onDelete }) {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-heading font-bold uppercase text-primary">Gerenciar Produtos</h2>
        <Button
          data-testid="create-product-button"
          onClick={onCreateNew}
          className="bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest font-bold px-6 py-3 rounded-sm"
        >
          <Plus className="w-5 h-5 mr-2" />
          Novo Produto
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => (
          <div key={product.id} data-testid={`product-${product.id}`} className="bg-card border border-border rounded-lg p-6">
            <h3 className="text-xl font-heading font-bold uppercase text-primary mb-2">{product.name}</h3>
            <p className="text-lg font-bold text-accent mb-4">R$ {product.price.toFixed(2)}</p>
            <div className="flex items-center gap-2">
              <Button
                data-testid={`edit-product-${product.id}`}
                size="sm"
                variant="outline"
                onClick={() => onEdit(product)}
                className="flex-1 rounded-sm"
              >
                <Edit className="w-4 h-4 mr-2" />
                Editar
              </Button>
              <Button
                data-testid={`delete-product-${product.id}`}
                size="sm"
                variant="destructive"
                onClick={() => onDelete(product.id)}
                className="flex-1 rounded-sm"
              >
                <Trash2 className="w-4 h-4 mr-2" />
                Excluir
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
